import React from 'react';
import { Box, Flex, IconButton, Text } from '@chakra-ui/react';
import { FiChevronLeft, FiX } from 'react-icons/fi';
import { useNavigate, useLocation } from 'react-router-dom';
import { Campaign, Collab } from '@foodfluence/shared';
import CounterCollabForm from '../components/counter-flow/CounterCollabForm';
import { ff } from '../../../theme';

const HEADER_BUTTON = {
  flex: 'none',
  w: '44px',
  h: '44px',
  minW: '44px',
  borderRadius: 'full',
  bg: 'transparent',
  color: ff.ink,
  _hover: { bg: ff.grey },
} as const;

const CounterCollabPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { collab, campaign, reason }: { collab: Collab, campaign: Campaign, reason: string } = location.state || {};

  return (
    <Box minH="100svh" bg="white" fontFamily="display" color={ff.ink}>
      <Flex maxW={{ base: "560px", lg: "720px" }} mx="auto" px="12px" pt="12px" align="center" gap="8px">
        <IconButton aria-label="Go back" icon={<FiChevronLeft size={22} strokeWidth={2.4} />} onClick={() => navigate(-1)} {...HEADER_BUTTON} />
        <Text as="h2" flex={1} fontSize="12px" fontWeight={600} letterSpacing="0.08em" textTransform="uppercase" color="#55555A" lineHeight="normal">
          Counter offer
        </Text>
        <IconButton aria-label="Close" icon={<FiX size={18} strokeWidth={2.4} />} onClick={() => navigate(-1)} {...HEADER_BUTTON} />
      </Flex>
      <Box maxW={{ base: "560px", lg: "720px" }} mx="auto" px="20px" pt="8px">
        <CounterCollabForm collab={collab} campaign={campaign} reason={reason} onSubmitted={() => navigate('/collabs')} />
      </Box>
    </Box>
  );
};

export default CounterCollabPage;
